import React from "react";
import { Tooltip as AntdTooltip } from "antd";
import { color } from "src/styles/globals";
import {
  TooltipContentContainer,
  TooltipContentBody,
  TooltipContentImage,
  StyledTooptipDesktopContainer,
} from "./TooltipDesktop.styled";

interface TooltipDesktopProps {
  children: React.ReactNode;
  tooltipContent: string;
  tooltipVisible: boolean;
  setTooltipVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const TooltipDesktop = ({
  children,
  tooltipContent,
  tooltipVisible,
  setTooltipVisible,
}: TooltipDesktopProps) => {
  const TooltipContent = (
    <TooltipContentContainer>
      <TooltipContentBody>{tooltipContent}</TooltipContentBody>
      <TooltipContentImage
        src="/static/pages/userProfile/x-circle-grayscale.svg"
        alt="Close Icon"
        onClick={() => setTooltipVisible(false)}
      />
    </TooltipContentContainer>
  );
  const TooltipInnerStyle = {
    backgroundColor: color.charcoal10,
    borderRadius: "8px",
    padding: "12px",
  };
  return (
    <StyledTooptipDesktopContainer>
      <AntdTooltip
        title={TooltipContent}
        color={color.charcoal10}
        placement="bottom"
        visible={tooltipVisible}
        overlayStyle={{ maxWidth: "100%" }}
        overlayInnerStyle={TooltipInnerStyle}
        autoAdjustOverflow={{ adjustX: 0, adjustY: 0 }}
        align={{ targetOffset: [96, 2] }}
        getPopupContainer={(triggerNode: HTMLElement) =>
          triggerNode.parentNode as HTMLElement
        }
      >
        {children}
      </AntdTooltip>
    </StyledTooptipDesktopContainer>
  );
};

export default TooltipDesktop;
